module.exports = __webpack_public_path__ + "static/media/Intransit truck 1.6f80b0aa.svg";